import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";


/**
 * @function OpenNewWindowModal
 * @param {STRING} onClick - Allows us to apply an event handler on click.
 * @returns {React.Component}
 * @exported true
 * @description This is the modal asks users if they want to open a new browser window
 * @example
 * <OpenNewWindowModal />
 */
export default function OpenNewWindowModal(props) {
  const data = props.data ?? {};

  return(
    <CustomModal id="OpenNewWindowModal" className="open-new-window-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <SVGAsset id="UpsellIcon" className="upsell-icon left-icon blue-icon set-width" />
        <div className="flex-width">
          <h4 className="modal-title"><b>Open a new browser window?</b></h4>
          <p className="sub-text">You will be redirected to a new browser window. Do you want to continue?</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container">
        <ModalCloseButton text="Cancel" id="OpenNewWindowModal" />
        <ModalPrimaryButton text="Open browser" onClick={ data.onClick }/>
      </CustomModalFooter>
    </CustomModal>
  );
}